import moment from 'moment'

import { getAvatars, getAvatarsLastModified } from 'services/apis/avatar'

import { logger } from './logger'

const OH_AVATAR_STORE = 'OH_AVATAR_STORE'

const initializeStore = () => ({
    avatars: {},
})

const getStore = () => {
    let store = localStorage.getItem(OH_AVATAR_STORE)
    store = store ? JSON.parse(store) : initializeStore()
    return store
}

let store = getStore()

const isExpired = (d1, d2) => moment(d1).diff(moment(d2), 'seconds') < 0

const clear = () => localStorage.removeItem(OH_AVATAR_STORE)

const save = () => {
    clear()
    localStorage.setItem(OH_AVATAR_STORE, JSON.stringify(store))
}

const get = uuid => store.avatars[uuid]

const add = (uuid, svg, background, head, modified) => {
    store.avatars = {
        ...store.avatars,
        [uuid]: {
            svg,
            background,
            head,
            modified,
        },
    }
}

const invalidate = (uuids = []) =>
    new Promise(resolve => {
        if (!uuids?.length) return
        const uuidsStr = uuids.join(',')
        const uuidsToInvalidate = []
        // eslint-disable-next-line
        ;(async () => {
            const response = await getAvatarsLastModified(uuidsStr)
            if (response.data.error) return

            response.data.results.forEach(result => {
                const modifiedAt = get(result.user_uuid)?.modified
                const isInvalid =
                    !modifiedAt || isExpired(modifiedAt, result.modified)
                isInvalid && uuidsToInvalidate.push(result.user_uuid)
            })

            return resolve(uuidsToInvalidate)
        })()
    })

const populate = (uuids = []) => {
    if (!uuids.length) return
    try {
        // eslint-disable-next-line
        ;(async () => {
            const uuidsToInvalidate = await invalidate(uuids)
            if (!uuidsToInvalidate?.length) return

            let avatars = await getAvatars(uuids.join(','))

            if (avatars.data.error) return

            avatars = avatars?.data?.results

            if (avatars) {
                avatars.forEach(avatar => {
                    add(
                        avatar.user_uuid,
                        avatar.rendered_transparent_svg,
                        avatar.background_path,
                        avatar.rendered_transparent_without_outfit,
                        avatar.modified
                    )
                })
            }

            save()
        })()
    } catch (error) {
        logger.error(error)
    }
}

export default {
    populate,
    get,
}
